import LoadUsuario from "../services/LoadUsuario";
import UserService from "../services/UserService";
import RoleService from "../services/RoleService";
import MenuService from "../services/MenuService";
import CompanyService from "../services/CompanyService";
import CatalogService from "../services/CatalogService";
import ParameterService from "../services/ParameterService";
import ProviderService from "../services/ProviderService";
import PatientService from "../services/PatientService";
import VaccineService from "../services/VaccineService";
import LaboratoryExamService from "../services/LaboratoryExamService";
import ProcedureService from "../services/ProcedureService";
import TypeService from "../services/TypeService";
import ElementService from "../services/ElementService";
import CompanyAgencyService from "../services/CompanyAgencyService";
import CompanyJobService from "../services/CompanyJobService";
import GuiaProessatService from "../services/GuiaProessatService";
import RouteSheetService from "../services/RouteSheetService";
import VueJwtDecode from 'vue-jwt-decode'
import router from '../router'
import GrupoHomogenioExposicionService from "../services/GrupoHomogenioExposicionService";
import DangerousProcessService from "../services/DangerousProcessService";
import PatientMonitoringService from  "../services/PatientMonitoringService";
import PatientRouteSheetService from  "../services/PatientRouteSheetService";
import PatientAnamnesisService from  "../services/PatientAnamnesisService";
import PatientEvolutionService from  "../services/PatientEvolutionService";
import PatientEmergencyService from  "../services/PatientEmergencyService";
import PatientAudioService from  "../services/PatientAudioService";
import PatientJobAndHealthService from  "../services/PatientHealthAndJobService";
import PatientOftalmoService from  "../services/PatientOftalmoService";
import PatientFpeService from  "../services/PatientFpeService";
import PatientRouteSheetStatusService from  "../services/PatientRouteSheetStatusService";
import PatientFileService from  "../services/PatientFileService";
import CovidService from  "../services/CovidService";
import CovidTracerService from "../services/CovidTracerService";
import ExportProcessService from "../services/ExportProcessService";
import CovidPatientService from  "../services/CovidPatientService";
import CovidPatientAlarmService from  "../services/CovidPatientAlarmService";
import CovidPatientEvolutionService from  "../services/CovidPatientEvolutionService";
import CovidConfigurationService from  "../services/CovidConfigurationService";
import AptitudeWorkService from "../services/AptitudeWorkService";
import AuditService from "../services/AuditService";
import PatientVaccineService from "../services/PatientVaccineService";
import Cie10Service from "../services/Cie10Service";
import ActivityConfigurationService from "../services/ActivityConfigurationService";
import ActivityConfigurationCompanyService from "../services/ActivityConfigurationCompanyService";
import ActivityService from "../services/ActivityService";
import ActivityFileService from "../services/ActivityFileService";
import ActivityCompanyUsersService from "../services/ActivityCompanyUsersService";
import ActivityCompanyPeriod from "../services/ActivityCompanyPeriodService";






export default {
  //Método asincrono que realiza el login del usuario
  loadUsuario({ dispatch, commit, state },params){
    state.progress = true;
    LoadUsuario.getLoadUsuario(params)
      .then((response)=>{
        state.progress = false;
        sessionStorage.setItem("id_token",response.data.id_token);
        let clientData = VueJwtDecode.decode(response.data.id_token);
        state.idUser = clientData.sub;
        state.roles = clientData.auth.split(",");
        state.authenticated=true;
        state.errorLogin = false;
        dispatch('setUserInSession',state.idUser)
        if (state.authenticated) {
          router.push('/start');
        }
        return true;
      })
      .catch((error)=>{
        state.progress = false;
        if(error.response==null){
          state.dialogErrorMessage = "Error en el aplicativo por favor intente más tarde"
          state.dialogError = true;
          router.push('/login');
        }else{
          state.errorLogin = true;
          router.push('/login');
        }
      })
  },

    //Método asincrono que edita las usuarios
    setUserInSession({ dispatch, commit, state },params){
        state.progress = true;
        state.userInSession="";
        return new Promise((resolve, reject) => {
            resolve(UserService.getUser(params)
                .then((response)=>{
                    state.progress = false;
                    state.userInSession=response.data
                })        .catch((error)=>{
                    dispatch("createDialogError",error)
                }))

        })
    },
  changePassword({ dispatch, commit, state },params){
    state.progress = true;
  return new Promise((resolve, reject) => {
    LoadUsuario.changePassword(params)
      .then((response)=>{
        state.progress = false
      })
      .catch((error)=>{
        dispatch("createDialogError",error)
      })
  }, error => {
    state.progress = false;
    // http failed, let the calling function know that action did not work out
    reject(error);
  })
  },
  changePasswordNotSession({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      LoadUsuario.changePasswordNotSession(params)
        .then((response)=>{
          state.progress = false;
          router.push('/login');
        })
        .catch((error)=>{
          dispatch("createDialogError",error)
        })
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  requestPasswordReset({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(LoadUsuario.requestPasswordReset(params)
        .then((response)=>{
          state.progress = false;
          router.push('/login');
          state.dialogErrorHeader= "Éxito en recuperación de contraseña"
          state.dialogError= true;
          state.dialogErrorMessage= "Se ha enviado un correo electrónico para el cambio de contraseña"
        })
        .catch((error)=>{
          state.progress = false;
          dispatch("createDialogError",error)
        }))
    })
  },

  //Método asincrono que obtiene las compañias
  getCompanies(context){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
    context.state.companies=[];
    CompanyService.getCompanies()
      .then((response)=>{
        context.state.progress = false;
        for (let i=0;i<response.data.length;i++) {
          context.state.companies.push({
              id: response.data[i].id,
              code: response.data[i].code,
              name: response.data[i].name,
              status: response.data[i].status,
              address: response.data[i].address,
              phone: response.data[i].phone,
              agent: response.data[i].agent,
              ciiu: {field: response.data[i].ciiu!=null?response.data[i].ciiu.id:"", text: response.data[i].ciiu!=null?response.data[i].ciiu.name:""},
              observation: response.data[i].observation,
              costCenter: response.data[i].costCenter
          });
        }
      })
      .catch((error)=>{
        context.dispatch("createDialogError",error)
      })
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

    //Método asincrono que obtiene las compañias
    getCompaniesStatusActive(context){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            context.state.companies=[];
            CompanyService.getCompanies()
                .then((response)=>{
                    context.state.progress = false;
                    for (let i=0;i<response.data.length;i++) {
                        if(response.data[i].status==true){
                            context.state.companies.push({
                                id: response.data[i].id,
                                code: response.data[i].code,
                                name: response.data[i].name,
                                status: response.data[i].status,
                                address: response.data[i].address,
                                phone: response.data[i].phone,
                                agent: response.data[i].agent,
                                ciiu: {field: response.data[i].ciiu!=null?response.data[i].ciiu.id:"", text: response.data[i].ciiu!=null?response.data[i].ciiu.name:""},
                                observation: response.data[i].observation,
                                costCenter: response.data[i].costCenter
                            });
                        }
                    }
                })
                .catch((error)=>{
                    context.dispatch("createDialogError",error)
                })
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },
  //Método asincrono que añade las compañias
  addCompany({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
    CompanyService.addCompany(params)
      .then((response)=>{
        state.progress = false;
        dispatch("getCompanies");
        router.push('/company');
      })
      .catch((error)=>{
        dispatch("createDialogError",error)
      })
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que edita las compañias
  updateCompany({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
    CompanyService.updateCompany(params)
      .then((response)=>{
        state.progress = false;
        dispatch("getCompanies");
        router.push('/company');
      })
      .catch((error)=>{
        dispatch("createDialogError",error)
      })
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que elimina las compañias
  deleteCompany({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
    CompanyService.deleteCompany(params)
      .then((response)=>{
        state.progress = false;
        dispatch("getCompanies");
        router.push('/company');
      })
      .catch((error)=>{
        dispatch("createDialogError",error)
      })
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que obtiene las compañias
  getRoles(context){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.rolesList=[];
      RoleService.getRoles()
        .then((response)=>{
          context.state.progress = false;
          for (let i=0;i<response.data.length;i++) {
            context.state.rolesList.push({
              name: response.data[i].name,
              description: response.data[i].description,
              status: response.data[i].status
            });
          }
        })
        .catch((error)=>{
          context.dispatch("createDialogError",error)
        })
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que añade las compañias
  addRole({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      RoleService.addRole(params)
        .then((response)=>{
          state.progress = false;
          dispatch("getRoles");
          router.push('/role');
        })
        .catch((error)=>{
          dispatch("createDialogError",error)
        })
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que edita las compañias
  updateRole({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      RoleService.updateRole(params)
        .then((response)=>{
          state.progress = false;
          dispatch("getRoles");
          router.push('/role');
        })
        .catch((error)=>{
          dispatch("createDialogError",error)
        })
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que elimina las compañias
  deleteRole({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      RoleService.deleteRole(params)
        .then((response)=>{
          state.progress = false;
          dispatch("getRoles");
          router.push('/role');
        })
        .catch((error)=>{
          dispatch("createDialogError",error)
        })
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
 //Método asincrono que obtiene los parámetros
  getParameters(context){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
    context.state.parameters=[];
    ParameterService.getParameters()
      .then((response)=>{
        context.state.progress = false;
        for (let i=0;i<response.data.length;i++) {
          context.state.parameters.push({
            id: response.data[i].id,
            value: response.data[i].value,
            name: response.data[i].name,
            enabled: response.data[i].enabled,
            flowTypeId: response.data[i].flowTypeId
          });
        }
      })
      .catch((error)=>{
        context.dispatch("createDialogError",error)
      })
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que añade los parámetros
  addParameter({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
    ParameterService.addParameter(params)
      .then((response)=>{
        state.progress = false;
        dispatch("getParameters");
        router.push('/parameter');
      })
      .catch((error)=>{
        dispatch("createDialogError",error)
      })
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que edita los parámetros
  updateParameter({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
    ParameterService.updateParameter(params)
      .then((response)=>{
        state.progress = false;
        dispatch("getParameters");
        router.push('/parameter');
      })
      .catch((error)=>{
        dispatch("createDialogError",error)
      })
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que elimina los parámetros
  deleteParameter({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
    ParameterService.deleteParameter(params)
      .then((response)=>{
        state.progress = false;
        dispatch("getParameters");
        router.push('/parameter');
      })
      .catch((error)=>{
        dispatch("createDialogError",error)
      })
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que obtiene los catálogos
  getCatalogs(context){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
    context.state.catalogs=[];
    CatalogService.getCatalogs()
      .then((response)=>{
        context.state.progress = false;
        for (let i=0;i<response.data.length;i++) {
          context.state.catalogs.push({
            id: response.data[i].id,
            code: response.data[i].code,
            name: response.data[i].name,
            enabled: response.data[i].enabled,
            catalogueItemId: response.data[i].catalogueItemId,
            type: response.data[i].type
          });
        }
      })
      .catch((error)=>{
        context.dispatch("createDialogError",error)
      })
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que añade los catálogos
  addCatalog({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
    CatalogService.addCatalog(params)
      .then((response)=>{
        state.progress = false;
        dispatch("getCatalogs");
        router.push('/catalog');
      })
      .catch((error)=>{
        dispatch("createDialogError",error)
      })
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que edita los catálogos
  updateCatalog({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
    CatalogService.updateCatalog(params)
      .then((response)=>{
        state.progress = false;
        dispatch("getCatalogs");
        router.push('/catalog');
      })
      .catch((error)=>{
        dispatch("createDialogError",error)
      })
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que elimina los catálogos
  deleteCatalog({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
    CatalogService.deleteCatalog(params)
      .then((response)=>{
        state.progress = false;
        dispatch("getCatalogs");
        router.push('/catalog');
      })
      .catch((error)=>{
        dispatch("createDialogError",error)
      })
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  findCatalogByType(context, params){
    return new Promise((resolve, reject) => {
    context.state.catalogs=[];
    CatalogService.findByType(params)
      .then((response)=>{
        context.state.progress = false;
        for (let i=0;i<response.data.length;i++) {
          context.state.catalogs.push({
            field:response.data[i].id,
            text:response.data[i].name
          });
        }
      })
      .catch((error)=>{
        context.dispatch("createDialogError",error)
      })
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  findCatalogByTypeResolve(context, params){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
    let catalogs=[];
    resolve(CatalogService.findByType(params)
      .then((response)=>{
        context.state.progress = false;
        for (let i=0;i<response.data.length;i++) {
          catalogs.push(response.data[i]);
        }
        return catalogs;
      }))
      .catch((error)=>{
        context.dispatch("createDialogError",error)
      })
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  findCatalogChildrenResolve(context, params){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
    let catalogChildren=[];
    resolve(CatalogService.findChildren(params)
      .then((response)=>{
        context.state.progress = false;
        for (let i=0;i<response.data.length;i++) {
          catalogChildren.push(
            response.data[i]
          );
        }
        return catalogChildren;
      }))
      .catch((error)=>{
        context.dispatch("createDialogError",error)
      })
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  findRouteSheetByCompany(context, params){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
    context.state.routeSheet=[];
    resolve(RouteSheetService.findByCompanyId(params)
      .then((response)=>{
          context.state.progress = false;
          return response
    }))
      .catch((error)=>{
        context.dispatch("createDialogError",error)
      })
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asíncrono que obtiene los usuarios asociados a un listado roles
  getUsersByRoleNames(context, params) {
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.usersByRol = [];
      RoleService.getUsersByRoleNames(params)
        .then((response) => {
          context.state.progress = false;
          for (let i = 0; i < response.data.length; i++) {
            context.state.usersByRol.push({
              id: response.data[i].id,
              login: response.data[i].login,
              firstName: response.data[i].firstName,
              lastName: response.data[i].lastName,
              email: response.data[i].email,
              identification: response.data[i].identification,
              degree: response.data[i].degree,
              specialty: response.data[i].specialty,
              position: response.data[i].position,
              activated: response.data[i].activated,
              authorities: response.data[i].authorities,
              cellphone: response.data[i].cellphone,
              birthday: response.data[i].birthday,
              document: response.data[i].document,
              documentType: response.data[i].documentType,
              city: response.data[i].city
            });
          }
        })
        .catch((error) => {
          context.dispatch("createDialogError",error)
        })
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que obtiene las usuarios
  getUsers(context){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.users=[];
      resolve(UserService.getUsers()
        .then((response)=>{
          context.state.progress = false;
          for (let i=0;i<response.data.length;i++) {
            response.data[i].completeName= response.data[i].firstName+" "+response.data[i].lastName+" - "+response.data[i].identification,
            context.state.users.push(response.data[i]);
          }
        }))
        .catch((error)=>{
          context.dispatch("createDialogError",error)
          reject(error);
        })
    })
  },

    //Método asincrono que obtiene las usuarios
    getUsersByCompany(context, params){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(UserService.getUsersByCompany(params)
                .then((response)=>{
                    let userArray=[]
                    for (let i = 0; i < response.data.length; i++) {
                        userArray.push({
                            id: response.data[i].id,
                            completeName: response.data[i].firstName+" "+response.data[i].lastName+" - "+response.data[i].identification,
                            firstName: response.data[i].firstName,
                            lastName: response.data[i].lastName,
                            email: response.data[i].email,
                            identification: response.data[i].identification,
                            degree: response.data[i].degree,
                            specialty: response.data[i].specialty,
                            position: response.data[i].position,
                            activated: response.data[i].activated,
                            authorities: response.data[i].authorities,
                            cellphone: response.data[i].cellphone,
                            birthday: response.data[i].birthday,
                            document: response.data[i].document,
                            documentType: response.data[i].documentType,
                            city: response.data[i].city
                        });
                    }
                    return userArray
                }))
                .catch((error)=>{
                    context.dispatch("createDialogError",error)
                    reject(error);
                })
        })
    },


    //Método asincrono que añade las usuarios
  addUser({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(UserService.addUser(params)
        .then((response)=>{
          state.progress = false;
          dispatch("getUsers")
        })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))

    })
  },
  //Método asincrono que edita las usuarios
  updateUser({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(UserService.updateUser(params)
        .then((response)=>{
          state.progress = false;
          dispatch("getUsers")
        })        .catch((error)=>{
            dispatch("createDialogError",error)
          }))

    })
  },

  //Método asincrono que elimina las usuarios
  deleteUser({ dispatch, commit, state  },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(UserService.deleteUser(params)
        .then((response)=>{
          state.progress = false;
          dispatch("getUsers")
        }))
    }, error => {
      dispatch("createDialogError",error);
      reject(error);
    })
  },
  getRols(context){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.allRols=[];
      UserService.getRols()
        .then((response)=>{
          context.state.progress = false;
          for (let i=0;i<response.data.length;i++) {
            context.state.allRols.push(response.data[i]);
          }
        })
        .catch((error)=>{
          context.dispatch("createDialogError",error)
        })
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que obtiene las los clientes para el flow
  getUsersReport(context){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.usersReport=[];
      UserService.getUsersReport()
        .then((response)=>{
          context.state.progress = false;
          context.state.usersReport=response.data
        })
        .catch((error)=>{
          context.dispatch("createDialogError",error)
        })
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  createDialogError({ dispatch, commit, state },error){
    if(error.response.status==401){
      state.dialogErrorMessage = "Sesión caducada. Por favor ingresar sus credenciales para acceder al sistema"
    }else{
      if(error.response.data.detail!=null && error.response.data.detail.includes("ConstraintViolationException")){
        state.dialogErrorMessage = "Existe un error de dependencia del registro, por favor verificar que el registro no esté siendo utilizado."
      }else{
        state.dialogErrorMessage = error.response.data.title!=null?error.response.data.title:"Se ha presentado un error en el aplicativo. Vuelva a intentarlo más tarde"

      }
    }
    state.dialogErrorHeader= "Error en la aplicación",
    state.progress = false;
    state.dialogError = true
  },
  getMenus(context){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
    context.state.menus=[];
    MenuService.getMenus()
      .then((response)=>{
        context.state.progress = false;
        for (let i=0;i<response.data.length;i++) {
          context.state.menus.push({
            id: response.data[i].id,
            icon: response.data[i].icon,
            title: response.data[i].title,
            route: response.data[i].route,
            description: response.data[i].description
          });
        }
      })
      .catch((error)=>{
        context.dispatch("createDialogError",error)
      })
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que añade las compañias
  addMenu({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      MenuService.addMenu(params)
      .then((response)=>{
        state.progress = false;
        dispatch("getMenus");
        router.push('/menu');
      })
      .catch((error)=>{
        dispatch("createDialogError",error)
      })
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que edita las compañias
  updateMenu({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      MenuService.updateMenu(params)
      .then((response)=>{
        state.progress = false;
        dispatch("getMenus");
        router.push('/menu');
      })
      .catch((error)=>{
        dispatch("createDialogError",error)
      })
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que elimi
  deleteMenu({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      MenuService.deleteMenu(params)
      .then((response)=>{
        state.progress = false;
        dispatch("getMenus");
        router.push('/menu');
      })
      .catch((error)=>{
        dispatch("createDialogError",error)
      })
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que obtiene providers
  getProviders(context){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.providers=[];
      resolve(ProviderService.getProviders()
          .then((response)=>{
            context.state.progress = false;
            for (let i=0;i<response.data.length;i++) {
              context.state.providers.push(response.data[i]);
            }
          }).catch((error)=>{
            dispatch("createDialogError",error)
          }))
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que añade los proveedores
  addProvider({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(ProviderService.addProvider(params)
          .then((response)=>{
            state.progress = false;
            dispatch("getProviders");
            router.push('/provider');
          }).catch((error)=>{
            dispatch("createDialogError",error)
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que edita los proveedores
  updateProvider({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(ProviderService.updateProvider(params)
          .then((response)=>{
            state.progress = false;
            dispatch("getProviders");
            router.push('/provider');
          }).catch((error)=>{
            dispatch("createDialogError",error)
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que elimina los proveedores
  deleteProvider({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(ProviderService.deleteProvider(params)
          .then((response)=>{
            state.progress = false;
            dispatch("getProviders");
            router.push('/provider');
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que obtiene los examenes de laboratorio
  getLaboratoryExams(context){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
    context.state.laboratoryExams=[];
    resolve (LaboratoryExamService.getLaboratoryExams()
      .then((response)=>{
        context.state.progress = false;
        for (let i=0;i<response.data.length;i++) {
          context.state.laboratoryExams.push(response.data[i]);
        }
      }).catch((error)=>{
          dispatch("createDialogError",error)
        }))
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que añade las compañias
  addLaboratoryExam({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve (LaboratoryExamService.addLaboratoryExam(params)
      .then((response)=>{
        state.progress = false;
        dispatch("getLaboratoryExams");
        router.push('/laboratoryExam');
      }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que edita las compañias
  updateLaboratoryExam({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve (LaboratoryExamService.updateLaboratoryExam(params)
      .then((response)=>{
        state.progress = false;
        dispatch("getLaboratoryExams");
        router.push('/laboratoryExam');
      }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que elimina las compañias
  deleteLaboratoryExam({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve (LaboratoryExamService.deleteLaboratoryExam(params)
      .then((response)=>{
        state.progress = false;
        dispatch("getLaboratoryExams");
        router.push('/laboratoryExam');
      }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que obtiene providers
  getVaccines(context){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.vaccines=[];
      resolve(VaccineService.getVaccines()
          .then((response)=>{
            context.state.progress = false;
            for (let i=0;i<response.data.length;i++) {
              context.state.vaccines.push(response.data[i]);
            }
          }))
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que añade los proveedores
  addVaccine({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(VaccineService.addVaccine(params)
          .then((response)=>{
            state.progress = false;
            dispatch("getVaccines");
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que edita los proveedores
  updateVaccine({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(VaccineService.updateVaccine(params)
          .then((response)=>{
            state.progress = false;
            dispatch("getVaccines");
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que elimina los proveedores
  deleteVaccine({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(VaccineService.deleteVaccine(params)
          .then((response)=>{
            state.progress = false;
            dispatch("getVaccines");
            router.push('/vaccine');
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  getAvailableVaccinesByPatientRouteSheet(context, params){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.vaccines=[];
      resolve(VaccineService.getAvailableVaccinesPerPatientRouteSheet(params)
          .then((response)=>{
            context.state.progress = false;
            for (let i=0;i<response.data.length;i++) {
              context.state.vaccines.push(response.data[i]);
            }
          }))
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  findAllOrderByName(context){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(VaccineService.findAllOrderByName());
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  findByDosisAndGroup(context,params){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(VaccineService.findByDosisAndGroup(params));
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que obtiene providers
  getProcedures(context){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.procedures=[];
      resolve(ProcedureService.getProcedures()
          .then((response)=>{
            context.state.progress = false;
            for (let i=0;i<response.data.length;i++) {
              context.state.procedures.push(response.data[i]);
            }
              context.state.procedures.sort((a, b) => (a.name > b.name) ? 1 : -1)
          }))
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que añade los proveedores
  addProcedure({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(ProcedureService.addProcedure(params)
          .then((response)=>{
            state.progress = false;
            dispatch("getProcedures");
            router.push('/procedure');
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que edita los proveedores
  updateProcedure({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(ProcedureService.updateProcedure(params)
          .then((response)=>{
            state.progress = false;
            dispatch("getProcedures");
            router.push('/procedure');
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que elimina los proveedores
  deleteProcedure({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(ProcedureService.deleteProcedure(params)
          .then((response)=>{
            state.progress = false;
            dispatch("getProcedures");
            router.push('/procedure');
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que obtiene tipos
  getTypes(context){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.types=[];
      resolve(TypeService.getTypes()
          .then((response)=>{
            context.state.progress = false;
            for (let i=0;i<response.data.length;i++) {
              context.state.types.push(response.data[i]);
            }
          }))
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que añade los tipos
  addType({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(TypeService.addType(params)
          .then((response)=>{
              for(let i=0;i<params.elements.length;i++){
                  if(params.elements[i].id==''){
                      params.elements[i].type=params.id
                      dispatch("addElement",params.elements[i])
                  }
              }
            state.progress = false;
            dispatch("getTypes")
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que edita los tipos
  updateType({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(TypeService.updateType(params)
          .then((response)=>{
            state.progress = false;
              for(let i=0;i<params.elements.length;i++){
                  if(params.elements[i].id==''){
                      params.elements[i].type=params.id
                      dispatch("addElement",params.elements[i])
                  }
              }
              dispatch("getTypes")
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que elimina los tipos
  deleteType({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(TypeService.deleteType(params)
          .then((response)=>{
            state.progress = false;
            dispatch("deleteElementsByType",params)
            dispatch("getTypes")
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que obtiene elementos
  getElements(context){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.elements=[];
      resolve(ElementService.getElements()
          .then((response)=>{
            context.state.progress = false;
            for (let i=0;i<response.data.length;i++) {
              context.state.elements.push(response.data[i]);
            }
          }))
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que obtiene elementos
  getElementsByType({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      state.elements=[];
      resolve(ElementService.getElementByType(params)
          .then((response)=>{
            state.progress = false;
            for (let i=0;i<response.data.length;i++) {
              state.elements.push(response.data[i]);
            }
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que añade los elementos
  addElement({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(ElementService.addElement(params)
          .then((response)=>{
            state.progress = false
            // dispatch("getElements")
            // router.push('/element');
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que edita los elementos
  updateElement({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(ElementService.updateElement(params)
          .then((response)=>{
            state.progress = false
            // dispatch("getElements")
            // router.push('/elements');
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que elimina los elementos
  deleteElementsByType({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(ElementService.deleteElementsByType(params)
          .then((response)=>{
            state.progress = false
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
    //Método asincrono que elimina los elementos
    deleteElement({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ElementService.deleteElement(params)
                .then((response)=>{
                    state.progress = false
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },
  //Método asincrono que obtiene providers
  getCompanyAgencies(context){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.companyAgencies=[];
      resolve(CompanyAgencyService.getCompanyAgencies()
          .then((response)=>{
            context.state.progress = false;
            for (let i=0;i<response.data.length;i++) {
              context.state.companyAgencies.push(response.data[i]);
            }
          }))
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que obtiene Agencias por compañia
  getCompanyAgenciesByCompany(context,params){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.companyAgencies=[];
      resolve(CompanyAgencyService.getCompanyAgenciesByCompany(params)
          .then((response)=>{
            context.state.progress = false;
            for (let i=0;i<response.data.length;i++) {
              context.state.companyAgencies.push(response.data[i]);
            }
          }))
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que añade las compañias
  addCompanyAgency({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve) => {
      resolve(CompanyAgencyService.addCompanyAgency(params)
          .then(()=>{
            state.progress = false
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que edita las agencias
  updateCompanyAgency({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve) => {
      resolve(CompanyAgencyService.updateCompanyAgency(params)
          .then(()=>{
            state.progress = false
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que elimina las agencias
  deleteCompanyAgency({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(CompanyAgencyService.deleteCompanyAgency(params)
          .then(()=>{
            state.progress = false
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que elimina las Agencias por compañias
  deleteCompanyAgencyByCompany({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(CompanyAgencyService.deleteCompanyAgencyByCompany(params)
          .then(()=>{
            state.progress = false
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

    //Método asincrono que obtiene Agencias por compañia
    getCompanyJobsByCompany(context,params){
        context.state.progress = true;
        return new Promise((resolve) => {
            context.state.companyJobs=[];
            resolve(CompanyJobService.getCompanyJobsByCompany(params)
                .then((response)=>{
                    context.state.progress = false;
                    for (let i=0;i<response.data.length;i++) {
                      if(response.data[i].detail==null){
                        response.data[i].jobMeasures=[]
                      }else{
                        response.data[i].jobMeasures=JSON.parse(response.data[i].detail)
                      }
                        context.state.companyJobs.push(response.data[i]);
                    }
                }))
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },
    //Método asincrono que añade las Puesto de trabajo
    addCompanyJob({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve) => {
            resolve(CompanyJobService.addCompanyJob(params)
                .then(()=>{
                  state.progress = false
                  //dispatch("getCompanyJobsByCompany",state.company.id);
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },
    //Método asincrono que edita los puestos de trabajo
    updateCompanyJob({ dispatch, commit, state },params){
    state.progress = true;
      return new Promise((resolve) => {
            resolve(CompanyJobService.updateCompanyJob(params)
                .then(()=>{
                    state.progress = false
                  // dispatch("getCompanyJobsByCompany",state.company.id);
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },
    //Método asincrono que elimina los puestos de trabajo
    deleteCompanyJob({ dispatch, commit, state },params){
        state.progress = true;
      state.companyJobs=[];
      return new Promise((resolve) => {
            resolve(CompanyJobService.deleteCompanyJob(params)
                .then(()=>{
                    state.progress = false
                  dispatch("getCompanyJobsByCompany",state.company.id);
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },
    //Método asincrono que elimina los puestos de trabajo por compañias
    deleteCompanyJobByCompany({ dispatch, commit, state },params){
        state.progress = true
        return new Promise((resolve) => {
            resolve(CompanyJobService.deleteCompanyJobByCompany(params)
                .then(()=>{
                    state.progress = false
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },
  //Método asincrono que obtiene las guias proessat
  getGuiasProessatByCompany(context,params){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.guiasProessat=[];
      resolve(GuiaProessatService.getGuiasProessatByCompany(params)
          .then((response)=>{
            context.state.progress = false;
            for (let i=0;i<response.data.length;i++) {
              context.state.guiasProessat.push(response.data[i]);
            }
          }))
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que obtiene elementos
  getGuiasProessatDataByGuiaProessat({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      state.guiasProessatData=[];
      resolve(GuiaProessatService.getGuiasProessatDataByGuiaProessat(params)
          .then((response)=>{
            state.progress = false;
            for (let i=0;i<response.data.length;i++) {
              state.guiasProessatData.push(response.data[i]);
            }
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que añade las guias proessat
  addGuiaProessat({ dispatch, commit, state },params){
    state.progress = true;
    let variable={id:"",area:params.area,description:params.description, company:params.company}
    return new Promise((resolve) => {
      resolve(GuiaProessatService.addGuiaProessat(variable)
          .then((response)=>{
            for(let i=0;i<params.guiaProessatData.length;i++){
              params.guiaProessatData[i].guiaProessat={id:response.data.id};
              dispatch("addGuiaProessatData",params.guiaProessatData[i])
            }
            state.progress = false;
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que añade los tipos
  addGuiaProessatData({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(GuiaProessatService.addGuiaProessatData(params)
          .then((response)=>{
            state.progress = false;
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que edita los tipos
  updateGuiaProessat({ dispatch, commit, state },params){
  state.progress = true;
  dispatch("deleteGuiaProessatDataByGuiaProessat",params.id)
  let variable={id:params.id,area:params.area,description:params.description, company:params.company}
  return new Promise((resolve) => {
    resolve(GuiaProessatService.updateGuiaProessat(variable)
        .then((response)=>{
          for(let i=0;i<params.guiaProessatData.length;i++){
            params.guiaProessatData[i].guiaProessat={id:response.data.id};
            dispatch("addGuiaProessatData",params.guiaProessatData[i])
          }
          state.progress = false;
        }))
  }, error => {
    state.progress = false;
    // http failed, let the calling function know that action did not work out
    reject(error);
  })
  },
  //Método asincrono que elimina los tipos
  deleteGuiaProessatDataByGuiaProessat({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(GuiaProessatService.deleteGuiaProessatDataByGuiaProessat(params)
          .then((response)=>{
            state.progress = false;
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que elimina los puestos de trabajo
  deleteGuiasProessat({ dispatch, commit, state },params){
    state.progress = true;
    dispatch("deleteGuiaProessatDataByGuiaProessat",params)
    return new Promise((resolve) => {
      resolve(GuiaProessatService.deleteGuiasProessat(params)
          .then(()=>{
            state.progress = false
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que añade los catálogos
  addRouteSheet({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      RouteSheetService.addRouteSheet(params)
      .then((response)=>{
        state.progress = false;
      })
      .catch((error)=>{
        dispatch("createDialogError",error)
      })
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  deleteByCompany({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(RouteSheetService.deleteByCompany(params)
      .then((response)=>{
        state.progress = false;
      })
      .catch((error)=>{
        dispatch("createDialogError",error)
      }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que obtiene grupos homogenios por companía
  getGruposHomogenio(context,params){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.gruposHomogenio=[];
      resolve(GrupoHomogenioExposicionService.getGruposHomogenioByCompany(params)
          .then((response)=>{
            context.state.progress = false;
            for (let i=0;i<response.data.length;i++) {
              context.state.gruposHomogenio.push(response.data[i]);
            }
          }))
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que añade los grupos homogenios
  addGruposHomogenio({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(GrupoHomogenioExposicionService.addGruposHomogenio(params)
          .then((response)=>{
            state.progress = false;
            dispatch("getGruposHomogenio",state.company.id);
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que edita los grupos homogenios
  updateGruposHomogenio({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(GrupoHomogenioExposicionService.updateGruposHomogenio(params)
          .then((response)=>{
            state.progress = false;
            dispatch("getGruposHomogenio",state.company.id);
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que elimina los grupos homogenios
  deleteGruposHomogenio({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(GrupoHomogenioExposicionService.deleteGruposHomogenio(params)
          .then((response)=>{
            state.progress = false;
            dispatch("getGruposHomogenio",state.company.id);
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que obtiene grupos homogenios por companía
  getDangerousProcess(context,params){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.dangerousProcesses=[];
      resolve(DangerousProcessService.getDangerousProcessesByCompany(params)
          .then((response)=>{
            context.state.progress = false;
            for (let i=0;i<response.data.length;i++) {
              context.state.dangerousProcesses.push(response.data[i]);
            }
          }))
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que añade los grupos homogenios
  addDangerousProcess({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(DangerousProcessService.addDangerousProcess(params)
          .then((response)=>{
            state.progress = false;
            dispatch("getDangerousProcess",state.company.id);
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que edita los grupos homogenios
  updateDangerousProcess({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(DangerousProcessService.updateDangerousProcess(params)
          .then((response)=>{
            state.progress = false;
            dispatch("getDangerousProcess",state.company.id);
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que elimina los grupos homogenios
  deleteDangerousProcess({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(DangerousProcessService.deleteDangerousProcess(params)
          .then((response)=>{
            state.progress = false;
            dispatch("getDangerousProcess",state.company.id);
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
    //Método asincrono que obtiene los catálogos
    getPatientsByUser(context){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            context.state.patients=[];
            PatientService.getPatientsByUser(context.state.idUser)
                .then((response)=>{
                    context.state.progress = false;
                    for (let i=0;i<response.data.length;i++) {
                        response.data[i].completeName = (response.data[i].firstLastName + " " + response.data[i].secondLastName + " " + response.data[i].firstName + " " + response.data[i].secondName).toUpperCase()
                        context.state.patients.push(response.data[i]);
                    }
                })
                .catch((error)=>{
                    context.dispatch("createDialogError",error)
                })
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },
  //Método asincrono que obtiene los catálogos
  getPatients(context){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
    context.state.patients=[];
    PatientService.getPatients()
      .then((response)=>{
        context.state.progress = false;
        for (let i=0;i<response.data.length;i++) {
          context.state.patients.push(response.data[i]);
        }
      })
      .catch((error)=>{
        context.dispatch("createDialogError",error)
      })
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que añade los catálogos
  addPatient({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(PatientService.addPatient(params)
      .then((response)=>{
        state.progress = false;
        dispatch("getPatientsByUser");
        router.push('/patient');
      })
      .catch((error)=>{
        dispatch("createDialogError",error)
      }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que edita los catálogos
  updatePatient({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(PatientService.updatePatient(params)
      .then((response)=>{
        state.progress = false;
        dispatch("getPatientsByUser");
        router.push('/patient');
      })
      .catch((error)=>{
        dispatch("createDialogError",error)
      }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que edita los catálogos
  updatePatientNoRedirect({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(PatientService.updatePatient(params)
          .then((response)=>{
            state.progress = false;
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que elimina los catálogos
  deletePatient({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(PatientService.deletePatient(params)
      .then((response)=>{
        state.progress = false;
        dispatch("getPatientsByUser");
        router.push('/patient');
      })
      .catch((error)=>{
        dispatch("createDialogError",error)
      }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que obtiene los catálogos
  getPatientMonitoring(context, params){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.patientMonitoringOne="";
      resolve(PatientMonitoringService.getPatientMonitoring(params)
          .then((response)=>{
            context.state.progress = false;
            context.state.patientMonitoringOne=response.data
          }))
          .catch((error)=>{
            context.dispatch("createDialogError",error)
          })
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que obtiene los catálogos
  getPatientMonitoringByRouteSheetForm(context,params){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.patientMonitoringList=[];
      resolve(PatientMonitoringService.getPatientMonitoringByRouteSheetForm(params)
          .then((response)=>{
            context.state.progress = false;
            for (let i=0;i<response.data.length;i++) {
              context.state.patientMonitoringList.push(response.data[i]);
            }
          }))
          .catch((error)=>{
            context.dispatch("createDialogError",error)
          })
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que añade los catálogos
  addPatientMonitoring({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(PatientMonitoringService.addPatientMonitoring(params)
          .then((response)=>{
            state.progress = false;
          }))
          .catch((error)=>{
            dispatch("createDialogError",error)
          })
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que edita los catálogos
  updatePatientMonitoring({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(PatientMonitoringService.updatePatientMonitoring(params)
          .then((response)=>{
            state.progress = false;
          }))
          .catch((error)=>{
            dispatch("createDialogError",error)
          })
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que elimina los catálogos
  deletePatientMonitoring({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(PatientMonitoringService.deletePatientMonitoring(params)
          .then((response)=>{
            state.progress = false;
          }))
          .catch((error)=>{
            dispatch("createDialogError",error)
          })
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  getPatientRouteSheetsByPatient(context, params){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.hojasRuta=[];
      resolve(PatientRouteSheetService.getPatientRouteSheetsByPatient(params)
          .then((response)=>{
            context.state.progress = false;
            for (let i=0;i<response.data.length;i++) {
              response.data[i].procedures=JSON.parse(response.data[i].detail)
              context.state.hojasRuta.push(response.data[i]);
            }
          })
          .catch((error)=>{
            context.dispatch("createDialogError",error)
          }))
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que obtiene los catálogos
  getPatientsRouteSheet(context){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.patients=[];
      resolve(PatientRouteSheetService.getPatientRouteSheets()
          .then((response)=>{
            context.state.progress = false;
            for (let i=0;i<response.data.length;i++) {
              context.state.patients.push(response.data[i]);
            }
          }))
          .catch((error)=>{
            context.dispatch("createDialogError",error)
          })
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que añade los catálogos
  addPatientRouteSheet({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(PatientRouteSheetService.addPatientRouteSheet(params)
          .then((response)=>{
            state.progress = false;
            dispatch("getPatientRouteSheetsByPatient",params.patient.id);
            router.push('/patientHojaRuta');
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que edita los catálogos
  updatePatientRouteSheet({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(PatientRouteSheetService.updatePatientRouteSheet(params)
          .then((response)=>{
            state.progress = false;
            dispatch("getPatientRouteSheetsByPatient",params.patient.id);
            router.push('/patientHojaRuta');
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que elimina los catálogos
  deletePatientRouteSheet({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(PatientRouteSheetService.deletePatientRouteSheet(params.id)
          .then((response)=>{
            state.progress = false;
            dispatch("getPatientRouteSheetsByPatient",params.patient.id);
            router.push('/patientHojaRuta');
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  getOpenedPatientsRouteSheet(context, params){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(PatientRouteSheetService.getOpenedPatientRouteSheets(params));
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  getExcelMsp() {
      return new Promise((resolve, reject) => {
          resolve(PatientAnamnesisService.getExcelMsp()
              .then((response)=>{
                  return response
              })
              .catch((error)=>{
                  context.dispatch("createDialogError",error)
              }))
      }, error => {
          context.state.progress = false;
          // http failed, let the calling function know that action did not work out
          reject(error);
      })
  },
  getExcelMsp2025() {
      return new Promise((resolve, reject) => {
          resolve(PatientAnamnesisService.getExcelMsp2025()
              .then((response)=>{
                  return response
              })
              .catch((error)=>{
                  context.dispatch("createDialogError",error)
              }))
      }, error => {
          context.state.progress = false;
          // http failed, let the calling function know that action did not work out
          reject(error);
      })
  },

    getPatientAnamnesisByRouteSheets(context, params){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.anamnesisList=[];
      resolve(PatientAnamnesisService.getPatientAnamnesisByRouteSheets(params)
          .then((response)=>{
            context.state.progress = false;
            for (let i=0;i<response.data.length;i++) {
              context.state.anamnesisList.push(response.data[i]);
            }
          })
          .catch((error)=>{
            context.dispatch("createDialogError",error)
          }))
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que obtiene los catálogos
  getPatientAnamnesis(context, params){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.anamnesisOne="";
      resolve(PatientAnamnesisService.getPatientAnamnesis(params)
          .then((response)=>{
            context.state.progress = false;
            context.state.anamnesisOne=response.data
          }))
          .catch((error)=>{
            context.dispatch("createDialogError",error)
          })
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que añade los catálogos
  addPatientAnamnesis({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(PatientAnamnesisService.addPatientAnamnesis(params)
          .then((response)=>{
            state.progress = false;
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que edita los catálogos
  updatePatientAnamnesis({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(PatientAnamnesisService.updatePatientAnamnesis(params)
          .then((response)=>{
            state.progress = false;
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que elimina los catálogos
  deletePatientAnamnesis({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(PatientAnamnesisService.deletePatientAnamnesis(params.id)
          .then((response)=>{
            state.progress = false;
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  getPatientJobAndHealthByRouteSheets(context, params){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.workAndHealthList=[];
      resolve(PatientJobAndHealthService.getPatientJobAndHealthByRouteSheets(params)
          .then((response)=>{
            context.state.progress = false;
            for (let i=0;i<response.data.length;i++) {
              context.state.workAndHealthList.push(response.data[i]);
            }
          })
          .catch((error)=>{
            context.dispatch("createDialogError",error)
          }))
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que obtiene los catálogos
  getPatientJobAndHealth(context, params){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.workAndHealthOne="";
      resolve(PatientJobAndHealthService.getPatientJobAndHealth(params)
          .then((response)=>{
            context.state.progress = false;
            context.state.workAndHealthOne=response.data
          }))
          .catch((error)=>{
            context.dispatch("createDialogError",error)
          })
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que añade los catálogos
  addPatientJobAndHealth({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(PatientJobAndHealthService.addPatientJobAndHealth(params)
          .then((response)=>{
            state.progress = false;
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que edita los catálogos
  updatePatientJobAndHealth({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(PatientJobAndHealthService.updatePatientJobAndHealth(params)
          .then((response)=>{
            state.progress = false;
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que elimina los catálogos
  deletePatientJobAndHealth({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(PatientJobAndHealthService.deletePatientJobAndHealth(params.id)
          .then((response)=>{
            state.progress = false;
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },


  getPatientFileByRouteSheets(context, params){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.patientFileList=[];
      resolve(PatientFileService.getPatientFileByRouteSheets(params)
          .then((response)=>{
            context.state.progress = false;
            for (let i=0;i<response.data.length;i++) {
                if(response.data[i].diagnostics!=null){
                    response.data[i].diagnostics = JSON.parse(response.data[i].diagnostics)
                }else{
                    response.data[i].diagnostics = []
                }
              context.state.patientFileList.push(response.data[i]);
            }
          })
          .catch((error)=>{
            context.dispatch("createDialogError",error)
          }))
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  getPatientFileByRouteSheetsResolve(context, params){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(PatientFileService.getPatientFileByRouteSheets(params));
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },


    getPatientFile(context, params){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(PatientFileService.getPatientFile(params)
                .then((response)=>{
                    context.state.progress = false;
                    return response
                })
                .catch((error)=>{
                    context.dispatch("createDialogError",error)
                }))
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

  //Método asincrono que añade los catálogos
  addPatientFile({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(PatientFileService.addPatientFile(params)
          .then((response)=>{
            state.progress = false;
            dispatch("getPatientFileByRouteSheets",params.patientRouteSheet.id);
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que edita los catálogos
  updatePatientFile({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(PatientFileService.updatePatientFile(params)
          .then((response)=>{
            state.progress = false;
            dispatch("getPatientFileByRouteSheets",params.patientRouteSheet.id);
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que elimina los catálogos
  deletePatientFile({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(PatientFileService.deletePatientFile(params)
          .then((response)=>{
            state.progress = false;
            dispatch("getPatientFileByRouteSheets",state.routeSheet.id);
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que obtiene las encuestas de covid
  getAllCovids(context, params){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.covidList=[];
      resolve(CovidService.getCovidList(params)
          .then((response)=>{
            context.state.progress = false;
            for (let i=0;i<response.data.length;i++) {
              context.state.covidList.push(response.data[i]);
            }
          }))
          .catch((error)=>{
            context.dispatch("createDialogError",error)
          })
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que obtiene las encuestas de covid
  getAllCovidsResolve(context, params){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(CovidService.getCovidList(params));
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

    //Método asincrono que obtiene las encuestas de covid
    getAllCovidsByCompany(context, getValue){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            context.state.covidList=[];
            resolve(CovidService.getCovidsByUser(context.state.idUser,getValue)
                .then((response)=>{
                   // context.state.progress = false;
                    for (let i=0;i<response.data.length;i++) {
                        context.state.covidList.push(response.data[i]);
                    }

                }))
                .catch((error)=>{
                    context.dispatch("createDialogError",error)
                })
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

  //Método asincrono que obtiene las encuestas de covid
  getAllCovidsByCompanyResolve(context, getValue){
      context.state.progress = true;
      return new Promise((resolve, reject) => {
          context.state.covidList=[];
          resolve(CovidService.getCovidsByUser(context.state.idUser,getValue));
      }, error => {
          context.state.progress = false;
          // http failed, let the calling function know that action did not work out
          reject(error);
      })
  },

  //Método asincrono que obtiene los catálogos
  getCovidOne(context, params){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.covidList=[];
      resolve(CovidService.getCovid(params)
          .then((response)=>{
            context.state.progress = false;
            return response.data
          }))
          .catch((error)=>{
            context.dispatch("createDialogError",error)
          })
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que añade los catálogos
  addCovid({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(CovidService.addCovid(params)
          .then((response)=>{
            state.progress = false;
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que edita los catálogos
  updateCovid({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(CovidService.updateCovid(params)
          .then((response)=>{
            state.progress = false;
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que elimina los catálogos
  deleteCovid({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(CovidService.deleteCovid(params)
          .then((response)=>{
            state.progress = false;
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que obtiene los catálogos
  getCovidTraceListByCovidId(context, params){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.covidTraceList=[];
      resolve(CovidTracerService.getCovidTraceListByCovidId(params)
          .then((response)=>{
            context.state.progress = false;
            for (let i=0;i<response.data.length;i++) {
              context.state.covidTraceList.push(response.data[i]);
            }
          }))
          .catch((error)=>{
            context.dispatch("createDialogError",error)
          })
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que obtiene los catálogos
  getCovidTraceListByCovidIdResolve(context, params){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.covidTraceList=[];
      context.state.progress = false;
      resolve(CovidTracerService.getCovidTraceListByCovidId(params));
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que añade los catálogos
  addCovidTrace({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(CovidTracerService.addCovidTrace(params)
          .then((response)=>{
            state.progress = false;
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que edita los catálogos
  updateCovidTrace({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(CovidTracerService.updateCovidTrace(params)
          .then((response)=>{
            state.progress = false;
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que elimina los catálogos
  deleteCovidTrace({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(CovidTracerService.deleteCovidTrace(params)
          .then((response)=>{
            state.progress = false;
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que obtiene los catálogos
  getCovidTraceByToken(context, params){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(CovidTracerService.getCovidTraceByToken(params)
          .then((response)=>{
            context.state.progress = false;
            return response.data
          }))
          .catch((error)=>{
            context.dispatch("createDialogError",error)
          })
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que obtiene los catálogos
  existCovid(context, params){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(CovidService.existCovid(params)
          .then((response)=>{
            context.state.progress = false;
            return response
          }))
          .catch((error)=>{
            context.dispatch("createDialogError",error)
          })
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

    //Método asincrono que obtiene la ultima ficha creada
    lastCovid(context, params){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            context.state.progress = false;
            resolve(CovidService.getLastCovid(params))
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },
  //Método asincrono que añade los procesos de exportacion
  addExportProcess({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(ExportProcessService.addExportProcess(params)
          .then((response)=>{
            state.progress = false;
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },


  //Método asincrono que obtiene todos los procesos de exportacion.
  getAllExportProcesses(context, params){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(ExportProcessService.getExportProcesses(params))
      }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
    //Método asincrono que obtiene todos los procesos de exportacion.
    getExportProcessConfiguration(context){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ExportProcessService.getExportProcessConfiguration()
                .then((response)=>{
                    context.state.progress = false;
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },


    //Método asincrono que añade los procesos de exportacion
    addExportProcessConfiguration({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ExportProcessService.addExportProcessConfiguration(params)
                .then((response)=>{
                    state.progress = false;
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    //Método asincrono que añade los procesos de exportacion
    updateExportProcessConfiguration({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ExportProcessService.updateExportProcessConfiguration(params)
                .then((response)=>{
                    state.progress = false;
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },
  //Método asincrono que obtiene los catálogos
  getCovidPatients(context, params){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.progress = false;
      resolve(CovidPatientService.getCovidPatients());
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

    //Método asincrono que obtiene los catálogos
    getCovidPatientsWithAlarm(context, params){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            context.state.progress = false;
            resolve(CovidPatientService.getCovidPatientsWithAlarm());
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },
    //Método asincrono que obtiene los catálogos
    getCovidPatientsWithAlarmAndCompany(context, params){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            //context.state.progress = false;
            resolve(CovidPatientService.getCovidPatientsWithAlarmAndCompany(context.state.idUser));
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    hasCovidAlarmToday(context, params){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            context.state.progress = false;
            resolve(CovidPatientAlarmService.hasCovidAlarmToday(params));
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },


    //Método asincrono que obtiene los catálogos
  getCovidPatientByIdentification(context, params){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.progress = false;
      resolve(CovidPatientService.getCovidPatientByIdentification(params));
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que añade los catálogos
  addCovidPatient({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(CovidPatientService.addCovidPatient(params)
          .then((response)=>{
            state.progress = false;
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que añade los catálogos
  addCovidPatienFromAlarm({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(CovidPatientService.addCovidPatient(params))
      state.progress = false;
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
    //Método asincrono que edita los catálogos
    updateCovidPatientFormAlarm({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(CovidPatientService.updateCovidPatient(params))
            state.progress = false;
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },
  //Método asincrono que edita los catálogos
  updateCovidPatient({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(CovidPatientService.updateCovidPatient(params)
          .then((response)=>{
            state.progress = false;
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que elimina los catálogos
  deleteCovidPatient({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(CovidPatientService.deleteCovidPatient(params)
          .then((response)=>{
            state.progress = false;
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que obtiene los catálogos
  sendCovidPatientAlarmMail(context, params){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.progress = false;
      resolve(CovidPatientAlarmService.sendCovidPatientAlarmMail(params));
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que obtiene los catálogos
  getCovidPatientAlarmByPatient(context, params){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.progress = false;
      resolve(CovidPatientAlarmService.getCovidPatientAlarmByPatient(params));
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que obtiene los catálogos
  getCovidPatientAlarms(context, params){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.progress = false;
      resolve(CovidPatientAlarmService.getCovidPatientAlarms());
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que añade los catálogos
  addCovidPatientAlarm({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(CovidPatientAlarmService.addCovidPatientAlarm(params))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que edita los catálogos
  updateCovidPatientAlarm({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(CovidPatientAlarmService.updateCovidPatientAlarm(params)
          .then((response)=>{
            state.progress = false;
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que elimina los catálogos
  deleteCovidPatientAlarm({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(CovidPatientAlarmService.deleteCovidPatientAlarm(params)
          .then((response)=>{
            state.progress = false;
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
    generateReportCovidPatientAlarm({ dispatch, commit, state }){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(CovidPatientAlarmService.generateReport(state.idUser))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },
    generateReportCovidPatientEvolutionAlarm({ dispatch, commit, state }){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(CovidPatientAlarmService.generateEvolutionReport(state.idUser))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    generateDoctorAsistantReport({ dispatch, commit, state }) {
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(CovidPatientAlarmService.generateDoctorAsistantReport())
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    //Método asincrono que obtiene los catálogos
  getCovidConfiguration(context){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
      context.state.progress = false;
      resolve(CovidConfigurationService.getCovidConfiguration(1));
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  //Método asincrono que añade los catálogos
  addCovidConfiguration({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(CovidConfigurationService.addCovidConfiguration(params)
          .then((response)=>{
            state.progress = false;
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que edita los catálogos
  updateCovidConfiguration({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(CovidConfigurationService.updateCovidConfiguration(params)
          .then((response)=>{
            state.progress = false;
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },
  //Método asincrono que elimina los catálogos
  deleteCovidConfiguration({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(CovidConfigurationService.deleteCovidConfiguration(params)
          .then((response)=>{
            state.progress = false;
          })
          .catch((error)=>{
            dispatch("createDialogError",error)
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

    //Método asincrono que obtiene los catálogos
    getCovidPatientEvolutionsByPatient(context, params){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            context.state.progress = false;
            resolve(CovidPatientEvolutionService.getCovidPatientEvolutionByPatient(params));
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    //Método asincrono que obtiene los catálogos
    getCovidPatientEvolutions(context, params){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            context.state.progress = false;
            resolve(CovidPatientEvolutionService.getCovidPatientEvolution(params));
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    //Método asincrono que añade los catálogos
    addCovidPatientEvolution({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(CovidPatientEvolutionService.addCovidPatientEvolution(params))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },
    //Método asincrono que edita los catálogos
    updateCovidPatientEvolution({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(CovidPatientEvolutionService.updateCovidPatientEvolution(params)
                .then((response)=>{
                    state.progress = false;
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },
    //Método asincrono que elimina los catálogos
    deleteCovidPatientEvolution({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(CovidPatientEvolutionService.deleteCovidPatientEvolution(params)
                .then((response)=>{
                    state.progress = false;
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

  //Método asincrono que añade la aptitud de trabajo
  addAptitudeWork({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      resolve(AptitudeWorkService.addAptitudeWork(params)
          .then((response)=>{
            state.progress = false;
          }))
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

  findAptitudeWorkByCovidPatientId(context, params){
    context.state.progress = true;
    return new Promise((resolve, reject) => {
    let aptitudeWorkList=[];
    resolve(AptitudeWorkService.findByCovidPatientId(params)
      .then((response)=>{
        context.state.progress = false;
        for (let i=0;i<response.data.length;i++) {
          aptitudeWorkList.push(response.data[i]);
        }
        return aptitudeWorkList;
      }))
      .catch((error)=>{
        context.dispatch("createDialogError",error)
      })
    }, error => {
      context.state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },



    //Método asincrono que obtiene los catálogos
    getPatientEvolutions(context, params){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            context.state.progress = false;
            resolve(PatientEvolutionService.getPatientEvolution(params));
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    //Método asincrono que añade los catálogos
    addPatientEvolution({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            state.progress = false;
            resolve(PatientEvolutionService.addPatientEvolution(params))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },
    //Método asincrono que edita los catálogos
    updatePatientEvolution({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(PatientEvolutionService.updatePatientEvolution(params)
                .then((response)=>{
                    state.progress = false;
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },
    //Método asincrono que elimina los catálogos
    deletePatientEvolution({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(PatientEvolutionService.deletePatientEvolution(params)
                .then((response)=>{
                    state.progress = false;
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    getPatientEvolutionByRouteSheets(context, params){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            context.state.progress = false;
            resolve(PatientEvolutionService.getPatientEvolutionByRouteSheets(params))
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    //Método asincrono que obtiene los catálogos
    getPatientAudios(context, params){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            context.state.progress = false;
            resolve(PatientAudioService.getPatientAudio(params));
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    //Método asincrono que añade los catálogos
    addPatientAudio({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            state.progress = false;
            resolve(PatientAudioService.addPatientAudio(params))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },
    //Método asincrono que edita los catálogos
    updatePatientAudio({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(PatientAudioService.updatePatientAudio(params)
                .then((response)=>{
                    state.progress = false;
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },
    //Método asincrono que elimina los catálogos
    deletePatientAudio({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(PatientAudioService.deletePatientAudio(params)
                .then((response)=>{
                    state.progress = false;
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    getPatientAudioByRouteSheets(context, params){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            context.state.progress = false;
            resolve(PatientAudioService.getPatientAudioByRouteSheets(params))
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    getAuditRecords(context, params){
      context.state.progress = true;
      return new Promise((resolve, reject) => {
          context.state.progress = false;
          resolve(AuditService.getAuditRecords(params));
      }, error => {
          context.state.progress = false;
          // http failed, let the calling function know that action did not work out
          reject(error);
      })

  },

    getAuditRecordsDateBetween(context, params){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            context.state.progress = false;
            resolve(AuditService.getAuditRecordsDate(params));
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })

    },



    //Método asincrono que obtiene los catálogos
    getPatientOftalmos(context, params){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            context.state.progress = false;
            resolve(PatientOftalmoService.getPatientOftalmos(params));
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    //Método asincrono que añade los catálogos
    addPatientOftalmo({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            state.progress = false;
            resolve(PatientOftalmoService.addPatientOftalmo(params))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },
    //Método asincrono que edita los catálogos
    updatePatientOftalmo({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(PatientOftalmoService.updatePatientOftalmo(params)
                .then((response)=>{
                    state.progress = false;
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },
    //Método asincrono que elimina los catálogos
    deletePatientOftalmo({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(PatientOftalmoService.deletePatientOftalmo(params)
                .then((response)=>{
                    state.progress = false;
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    getPatientOftalmoByRouteSheets(context, params){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            context.state.progress = false;
            resolve(PatientOftalmoService.getPatientOfatlmoByRouteSheets(params))
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },


    getPatientVaccines(context, params) {
      context.state.progress = true;
      return new Promise((resolve, reject) => {
          context.state.progress = false;
          resolve(PatientVaccineService.getPatientVaccines(params));
      }, error => {
          context.state.progress = false;
          // http failed, let the calling function know that action did not work out
          reject(error);
      })
    },

    addPatientVaccine({ dispatch, commit, state },params){
      state.progress = true;
      return new Promise((resolve, reject) => {
      resolve(PatientVaccineService.addPatientVaccine(params));
      }, error => {
        state.progress = false;
        // http failed, let the calling function know that action did not work out
        reject(error);
      })
    },

    updatePatientVaccine({ dispatch, commit, state },params){
      state.progress = true;
      return new Promise((resolve, reject) => {
      PatientVaccineService.updatePatientVaccine(params)
        .then((response)=>{
          state.progress = false;
        })
        .catch((error)=>{
          dispatch("createDialogError",error)
        })
      }, error => {
        state.progress = false;
        // http failed, let the calling function know that action did not work out
        reject(error);
      })
    },

    deletePatientVaccine({ dispatch, commit, state },params){
      state.progress = true;
      return new Promise((resolve, reject) => {
        PatientVaccineService.deletePatientVaccine(params)
        .then((response)=>{
          state.progress = false;
        })
        .catch((error)=>{
          dispatch("createDialogError",error)
        })
      }, error => {
        state.progress = false;
        // http failed, let the calling function know that action did not work out
        reject(error);
      })
    },

    getPatientVaccinesByRouteSheet(context, params) {
      context.state.progress = true;
      return new Promise((resolve, reject) => {
          context.state.progress = false;
          resolve(PatientVaccineService.getByPatientRouteSheet(params));
      }, error => {
          context.state.progress = false;
          // http failed, let the calling function know that action did not work out
          reject(error);
      })
    },

    getAlerts(context, params) {
      context.state.progress = true;
      return new Promise((resolve, reject) => {
          context.state.progress = false;
          resolve(PatientVaccineService.getAlerts(params));
      }, error => {
          console.log(error.response)
          context.state.progress = false;
          // http failed, let the calling function know that action did not work out
          reject(error);
      })
    },

    getPatientVaccineByCompanyId(context, params) {
      context.state.progress = true;
      return new Promise((resolve, reject) => {
          context.state.progress = false;
          resolve(PatientVaccineService.getByCompanyId(params));
      }, error => {
          console.log(error.response)
          context.state.progress = false;
          // http failed, let the calling function know that action did not work out
          reject(error);
      })
    },

    //Método asincrono que obtiene los catálogos
    getPatientFpe(context, params){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            context.state.progress = false;
            resolve(PatientFpeService.getPatientFpes(params));
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    //Método asincrono que añade los catálogos
    addPatientFpe({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            state.progress = false;
            resolve(PatientFpeService.addPatientFpe(params))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    //Método asincrono que edita los catálogos
    updatePatientFpe({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(PatientFpeService.updatePatientFpe(params)
                .then((response)=>{
                    state.progress = false;
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    //Método asincrono que elimina los catálogos
    deletePatientFpe({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(PatientFpeService.deletePatientFpe(params)
                .then((response)=>{
                    state.progress = false;
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    getPatientFpeByRouteSheets(context, params){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            context.state.progress = false;
            resolve(PatientFpeService.getPatientFpeByRouteSheets(params))
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },


    //Método asincrono que obtiene los catálogos
    getPatientRouteSheetStatus(context, params){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            context.state.progress = false;
            resolve(PatientRouteSheetStatusService.getPatientRouteSheets(params));
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    //Método asincrono que añade los catálogos
    addPatientRouteSheetStatus({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            state.progress = false;
            resolve(PatientRouteSheetStatusService.addPatientRouteSheet(params))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    //Método asincrono que edita los catálogos
    updatePatientRouteSheetStatus({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(PatientRouteSheetStatusService.updatePatientRouteSheet(params)
                .then((response)=>{
                    state.progress = false;
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    //Método asincrono que elimina los catálogos
    deletePatientRouteSheetStatus({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(PatientRouteSheetStatusService.deletePatientRouteSheet(params)
                .then((response)=>{
                    state.progress = false;
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    getPatientRouteSheetStatusByRouteSheets(context, params){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            context.state.progress = false;
            resolve(PatientRouteSheetStatusService.getPatientRouteSheetByRouteSheets(params))
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    //Método asincrono que obtiene los catálogos
    getPatientEmergencies(context, params){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            context.state.progress = false;
            resolve(PatientEmergencyService.getPatientEmergency(params));
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    //Método asincrono que añade los catálogos
    addPatientEmergency({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            state.progress = false;
            resolve(PatientEmergencyService.addPatientEmergency(params))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },
    //Método asincrono que edita los catálogos
    updatePatientEmergency({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(PatientEmergencyService.updatePatientEmergency(params)
                .then((response)=>{
                    state.progress = false;
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },
    //Método asincrono que elimina los catálogos
    deletePatientEmergency({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(PatientEmergencyService.deletePatientEmergency(params)
                .then((response)=>{
                    state.progress = false;
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    getPatientEmergencyByRouteSheets(context, params){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            context.state.progress = false;
            resolve(PatientEmergencyService.getPatientEmergencyByRouteSheets(params))
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    getCie10Groups(context){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            context.state.progress = false;
            resolve(Cie10Service.getCie10Groups())
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    getCie10SubGroups(context, params){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            context.state.progress = false;
            resolve(Cie10Service.getCie10SubGroups(params))
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    getCie10SubCategoryGroups(context, params){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            context.state.progress = false;
            resolve(Cie10Service.getCie10SubCategoryGroups(params))
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    findCie10SubCategoryGroupsByDescripcion(context, params){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            context.state.progress = false;
            resolve(Cie10Service.findCie10SubCategoryGroupsByDescripcion(params))
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    getActivityConfigurations(context){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ActivityConfigurationService.getActivityConfigurations()
                .then((response)=>{
                    context.state.progress = false;
                    return response
                })
                .catch((error)=>{
                    context.dispatch("createDialogError",error)
                }))
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    //Método asincrono que añade los catálogos
    addActivityConfiguration({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ActivityConfigurationService.addActivityConfiguration(params)
                .then((response)=>{
                    state.progress = false;
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },
    //Método asincrono que edita los catálogos
    updateActivityConfiguration({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ActivityConfigurationService.updateActivityConfiguration(params)
                .then((response)=>{
                    state.progress = false;
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },
    //Método asincrono que elimina los catálogos
    deleteActivityConfiguration({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ActivityConfigurationService.deleteActivityConfiguration(params)
                .then((response)=>{
                    state.progress = false;
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    //Método asincrono que edita los catálogos
    getActivityConfigurationsByFather({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ActivityConfigurationService.getActivityConfigurationsByFather(params)
                .then((response)=>{
                    state.progress = false;
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },


    getActivityConfigurationCompanies(context,params){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ActivityConfigurationCompanyService.getActivityConfigurationCompanies(params)
                .then((response)=>{
                    context.state.progress = false;
                    return response
                })
                .catch((error)=>{
                    context.dispatch("createDialogError",error)
                }))
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    //Método asincrono que añade los catálogos
    addActivityConfigurationCompany({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ActivityConfigurationCompanyService.addActivityConfigurationCompany(params)
                .then((response)=>{
                    state.progress = false;
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },
    //Método asincrono que edita los catálogos
    updateActivityConfigurationCompany({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ActivityConfigurationCompanyService.updateActivityConfigurationCompany(params)
                .then((response)=>{
                    state.progress = false;
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },
    //Método asincrono que elimina los catálogos
    deleteActivityConfigurationCompany({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ActivityConfigurationCompanyService.deleteActivityConfigurationCompany(params)
                .then((response)=>{
                    state.progress = false;
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    //Método asincrono que edita los catálogos
    getActivityConfigurationsCompanyByFather({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ActivityConfigurationCompanyService.getActivityConfigurationsCompanyByFather(params)
                .then((response)=>{
                    state.progress = false;
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },


    //Método asincrono que edita los catálogos
    createFirstDataActivityConfigurationsCompany({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ActivityConfigurationCompanyService.createFirstData(params)
                .then((response)=>{
                    state.progress = false;
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    //Método asincrono que edita los catálogos
    getActivityConfigurationCompanyAreEnable({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ActivityConfigurationCompanyService.getActivityConfigurationCompanyAreEnable(params)
                .then((response)=>{
                    state.progress = false;
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    getActivities(context){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ActivityService.getActivities()
                .then((response)=>{
                    context.state.progress = false;
                    return response
                })
                .catch((error)=>{
                    context.dispatch("createDialogError",error)
                }))
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    getActivitiesByCompany(context,params){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ActivityService.getActivitiesByCompany(params)
                .then((response)=>{
                    context.state.progress = false;
                    return response
                })
                .catch((error)=>{
                    context.dispatch("createDialogError",error)
                }))
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },



    //Método asincrono que añade los catálogos
    addActivity({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ActivityService.addActivity(params)
                .then((response)=>{
                    state.progress = false;
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },
    //Método asincrono que edita los catálogos
    updateActivity({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ActivityService.updateActivity(params)
                .then((response)=>{
                    state.progress = false;
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },
    //Método asincrono que elimina los catálogos
    deleteActivity({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ActivityService.deleteActivity(params)
                .then((response)=>{
                    state.progress = false;
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

  //Método asincrono que obtiene los usuarios por cliente en actividad
  getActivityCompanyUsers({ dispatch, commit, state }, params){
    state.progress = true;
    return new Promise((resolve, reject) => {
        resolve(ActivityCompanyUsersService.getUsersByCompanyActivity(params)
            .then((response)=>{
                state.progress = false;
                return response;
            })
            .catch((error)=>{
                dispatch("createDialogError",error)
            }))
    }, error => {
        state.progress = false;
        // http failed, let the calling function know that action did not work out
        reject(error);
    })
  },

    //Método asincrono que obtiene los usuarios por cliente en actividad
    getUsersCompanyActivityByUser({ dispatch, commit, state }, params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ActivityCompanyUsersService.getUsersCompanyActivityByUser(params)
                .then((response)=>{
                    state.progress = false;
                    return response;
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },



  //Método asincrono que añade los usuarios de cliente en actividad.
  addActivityCompanyUsers({ dispatch, commit, state },params){
    state.progress = true;
    return new Promise((resolve, reject) => {
      ActivityCompanyUsersService.addActivityCompanyUsers(params)
      .then((response)=>{
        state.progress = false;
      })
      .catch((error)=>{
        dispatch("createDialogError",error)
      })
    }, error => {
      state.progress = false;
      // http failed, let the calling function know that action did not work out
      reject(error);
    })
  },

    deleteActivityCompanyUsersByCompanyId({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ActivityCompanyUsersService.deleteByCompanyId(params)
                .then((response)=>{
                    state.progress = false;
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    findActivityExportProcess({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ActivityService.findActivityExportProcess(params)
                .then((response)=>{
                    state.progress = false;
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    findActivityDateStatus({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ActivityService.findActivityDateStatus(params)
                .then((response)=>{
                    state.progress = false;
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    getActivityFile(context,params){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ActivityFileService.getActivityFile(params)
                .then((response)=>{
                    context.state.progress = false;
                    return response
                })
                .catch((error)=>{
                    context.dispatch("createDialogError",error)
                }))
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    //Método asincrono que añade los catálogos
    addActivityFile({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ActivityFileService.addActivityFile(params)
                .then((response)=>{
                    state.progress = false;
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },
    //Método asincrono que edita los catálogos
    updateActivityFile({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ActivityFileService.updateActivityFile(params)
                .then((response)=>{
                    state.progress = false;
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },
    //Método asincrono que elimina los catálogos
    deleteActivityFile({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ActivityFileService.deleteActivityFile(params)
                .then((response)=>{
                    state.progress = false;
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    getActivityFileByActivity(context, params){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            context.state.activityFileList=[];
            resolve(ActivityFileService.getActivityFileByActivity(params)
                .then((response)=>{
                    context.state.progress = false;
                    context.state.activityFileList = response.data
                    return response
                })
                .catch((error)=>{
                    context.dispatch("createDialogError",error)
                }))
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    getCompanyPeriod(context,params){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ActivityCompanyPeriod.getPeriod(params)
                .then((response)=>{
                    context.state.progress = false;
                    return response
                })
                .catch((error)=>{
                    context.dispatch("createDialogError",error)
                }))
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    //Método asincrono que añade los catálogos
    addCompanyPeriod({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ActivityCompanyPeriod.addPeriod(params)
                .then((response)=>{
                    state.progress = false;
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },
    //Método asincrono que edita los catálogos
    updateCompanyPeriod({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ActivityCompanyPeriod.updatePeriod(params)
                .then((response)=>{
                    state.progress = false;
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },
    //Método asincrono que elimina los catálogos
    deleteCompanyPeriod({ dispatch, commit, state },params){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ActivityCompanyPeriod.deletePeriod(params)
                .then((response)=>{
                    state.progress = false;
                    return response
                })
                .catch((error)=>{
                    dispatch("createDialogError",error)
                }))
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    getCompanyPeriodByCompany(context, params){
        context.state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ActivityCompanyPeriod.getPeriodsByCompany(params)
                .then((response)=>{
                    context.state.progress = false;
                    return response
                })
                .catch((error)=>{
                    context.dispatch("createDialogError",error)
                }))
        }, error => {
            context.state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

    generateReportActivitiesExcel({ dispatch, commit, state }){
        state.progress = true;
        return new Promise((resolve, reject) => {
            resolve(ActivityCompanyPeriod.getReportExcel())
        }, error => {
            state.progress = false;
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
    },

}



// WEBPACK FOOTER //
// ./src/store/actions.js